<div class="draw-box" style="width: 100%; height: 100%;">
  <canvas id="myCanvas"></canvas>
</div>
